// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading-dots_loading__v23Bk","spacer":"loading-dots_spacer__f7MGV","blink":"loading-dots_blink__smB33"};